"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var dropzone_input_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/input/dropzone_input"));
var mobx_1 = require("mobx");
var ui_dropzone_png_1 = __importDefault(require("@hikakaku/shared/images/ui/ui-dropzone.png"));
var MAX_IMAGE_SIZE = 1200;
var DropzoneInputStore = /** @class */ (function () {
    function DropzoneInputStore(props) {
        var _this = this;
        this.component = dropzone_input_1.default;
        this.hasDragEntered = false;
        this.handleDrop = function (acceptedFiles) {
            var file = acceptedFiles.length === 0 ? undefined : acceptedFiles[0];
            if (file) {
                _this.updateFile(file);
            }
        };
        this.handleDragEnter = function () {
            _this.hasDragEntered = true;
        };
        this.handleDragLeave = function () {
            _this.hasDragEntered = false;
        };
        this.resetValue = function () {
            _this.fileName = undefined;
            _this.value = undefined;
        };
        this.updateFile = function (file) {
            if (!_this.ImageResizer)
                return;
            _this.ImageResizer.resize(file, MAX_IMAGE_SIZE, MAX_IMAGE_SIZE, function (dataUrl) {
                _this.fileName = file.name;
                _this.value = dataUrl;
            }, function (error) {
                var _a;
                if ((_a = _this.ImageResizer) === null || _a === void 0 ? void 0 : _a.isImageResizerError(error)) {
                    window.DialogStore.showDialogWithCloseButton(_this.ImageResizer.errorMesssage(error));
                }
                throw error;
            });
        };
        this.value = props.defaultValue;
        this.name = props.name;
        if (typeof window !== 'undefined') {
            Promise.resolve().then(function () { return __importStar(require('@hikakaku/shared/lib/image_resizer')); }).then(function (module) {
                _this.ImageResizer = module.ImageResizer;
            });
        }
    }
    Object.defineProperty(DropzoneInputStore.prototype, "dropzoneClassNames", {
        get: function () {
            return (0, classnames_1.default)('estimateForm-Dropzone', {
                'estimateForm-Dropzone-entered': this.hasDragEntered
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DropzoneInputStore.prototype, "thumbnail", {
        get: function () {
            return this.value || ui_dropzone_png_1.default;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], DropzoneInputStore.prototype, "hasDragEntered", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], DropzoneInputStore.prototype, "fileName", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], DropzoneInputStore.prototype, "value", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], DropzoneInputStore.prototype, "dropzoneClassNames", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], DropzoneInputStore.prototype, "thumbnail", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], DropzoneInputStore.prototype, "handleDrop", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], DropzoneInputStore.prototype, "handleDragEnter", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], DropzoneInputStore.prototype, "handleDragLeave", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], DropzoneInputStore.prototype, "resetValue", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], DropzoneInputStore.prototype, "updateFile", void 0);
    return DropzoneInputStore;
}());
exports.default = DropzoneInputStore;
